import i18next from 'i18next';

import { itemsAmountSum } from '../../shared/utils/amountSum';
import { getTaxAmount } from '../../shared/utils/vatAndDiscount';
import voucherTypes from '../../constants/defaultCodes/voucherTypes';
import { getVoucherNumber } from '../../controllers/transactions/transactionControllers';

const { PURCHASE_RETURN } = voucherTypes;

export const validateVoucherNo = async (data: any, errors: any) => {
  const newVoucherNumber = await getVoucherNumber(PURCHASE_RETURN);
  let isVoucherNoValid = true;

  if (data.voucherNumber !== newVoucherNumber) {
    errors = {
      ...errors,
      voucherNumber: i18next.t('voucher.validation.voucherNoExist'),
    };
    isVoucherNoValid = false;
  } else {
    delete errors.voucherNumber;
  }

  return { isVoucherNoValid, errss: errors };
};

export const validatePurchaseReturn = (data: any, errors: any) => {
  let isValid = true;

  if (!data.voucherNumber) {
    errors = {
      ...errors,
      voucherNumber: i18next.t('voucher.validation.voucherNoRequired'),
    };
    isValid = false;
  } else if (data.voucherNumber.length > 20) {
    errors = {
      ...errors,
      voucherNumber: i18next.t('voucher.validation.voucherNoLength'),
    };
    isValid = false;
  } else {
    delete errors.voucherNumber;
  }

  if (data.description && data.description.length > 256) {
    errors = {
      ...errors,
      description: i18next.t('voucher.validation.descriptionLength'),
    };
    isValid = false;
  } else {
    delete errors.description;
  }

  if (data.voucherDate === undefined) {
    errors = {
      ...errors,
      voucherDate: i18next.t('voucher.validation.voucherDateRequired'),
    };
    isValid = false;
  } else {
    delete errors.voucherDate;
  }

  if (!data.isFullPayment && !data.vendor) {
    errors = {
      ...errors,
      vendor: i18next.t('voucher.validation.vendorRequired'),
    };
    isValid = false;
  } else {
    delete errors.vendor;
  }

  if (data.referenceId && data.referenceId.length > 32) {
    errors = {
      ...errors,
      referenceId: i18next.t('voucher.validation.referenceIdLength'),
    };
    isValid = false;
  } else {
    delete errors.referenceId;
  }

  if (!data.voucherItems.length) {
    errors = {
      ...errors,
      returnItem: 'Return Item is required',
    };
    isValid = false;
  } else {
    delete errors.returnItem;
  }

  if (data.paidAmount) {
    const { isTaxable } = data;
    const discountAmount = Number(data.discountAmount || 0);
    const amountSum = itemsAmountSum(data.voucherItems);
    const taxAmount = getTaxAmount(isTaxable, discountAmount, amountSum, 13);

    const finalRawAmount = amountSum - discountAmount + (+taxAmount || 0);
    const finalAmount = +finalRawAmount.toFixed(2);

    if (data.paidAmount > finalAmount) {
      errors = {
        ...errors,
        paidAmount: i18next.t('invoice.validation.invalidPaidAmount'),
      };
      isValid = false;
    }

    if (!data.isFullPayment && data.paidAmount === finalAmount) {
      errors = {
        ...errors,
        paidAmount: i18next.t('invoice.validation.isCashPayment'),
      };
      isValid = false;
    }
  } else {
    delete errors.paidAmount;
  }

  if ((data.paidAmount || data.isFullPayment) && !data.cashInAccount) {
    errors = {
      ...errors,
      cashInAccount: i18next.t('purchaseReturn.validation.cashInAccountReq'),
    };
    isValid = false;
  } else {
    delete errors.cashInAccount;
  }

  data.voucherItems.forEach((voucherItem: any) => {
    const accountField = `${voucherItem.lineNo}-account`;
    const amountField = `${voucherItem.lineNo}-amount`;

    if (!voucherItem.account) {
      errors = {
        ...errors,
        [accountField]: i18next.t(
          'purchaseReturn.validation.billAccountRequired',
        ),
      };
      isValid = false;
    } else {
      delete errors[accountField];
    }

    if (!voucherItem.amount || voucherItem.amount <= 0) {
      errors = {
        ...errors,
        [amountField]: i18next.t(
          'purchaseReturn.validation.returnAmountRequired',
        ),
      };
      isValid = false;
    } else {
      delete errors[amountField];
    }
  });

  if (
    data.discountAmount &&
    data.discountAmount > itemsAmountSum(data.voucherItems)
  ) {
    errors = {
      ...errors,
      discountAmount: i18next.t('bilinvoice.validation.invalidDiscount'),
    };
    isValid = false;
  } else {
    delete errors.discountAmount;
  }

  return { isValid, errs: errors };
};
